import { Pipe, PipeTransform } from '@angular/core';
import { ProductCategory } from '@platform-frontend/marketplace';
import { PLATFORM_ENVIRONMENT } from '@platform-frontend/platform';

@Pipe({
  name: 'successLottiePath'
})
export class SuccessLottiePathPipe implements PipeTransform {
  transform(productCategory: ProductCategory | null): string {
    switch (productCategory) {
      case 'TRAVEL_TICKET':
        return PLATFORM_ENVIRONMENT.webshopUrl + '/assets/static/lottie/success-ticket-lottie.json';
      case 'PAID_CONTENT':
        return PLATFORM_ENVIRONMENT.webshopUrl + '/assets/static/lottie/success-paywall-lottie.json';
      case 'VOUCHER':
      case 'MEMBERSHIP':
      case 'SUPPORT':
      case 'SOFTWARE':
      default:
        return PLATFORM_ENVIRONMENT.webshopUrl + '/assets/static/lottie/success-software-lottie.json';
    }
  }
}
